// Constants for alignment points
export const alignmentPoints = {
  LEFT: 'left',
  RIGHT: 'right',
  TOP: 'top',
  BOTTOM: 'bottom',
  CENTER: 'center',
};

// Constants for alignment types built from alignment points
export const alignmentTypes = {
  // Left edge alignments
  LEFT_LEFT: `${alignmentPoints.LEFT}-${alignmentPoints.LEFT}`,
  LEFT_RIGHT: `${alignmentPoints.LEFT}-${alignmentPoints.RIGHT}`,
  LEFT_CENTER: `${alignmentPoints.LEFT}-${alignmentPoints.CENTER}`,

  // Right edge alignments
  RIGHT_LEFT: `${alignmentPoints.RIGHT}-${alignmentPoints.LEFT}`,
  RIGHT_RIGHT: `${alignmentPoints.RIGHT}-${alignmentPoints.RIGHT}`,
  RIGHT_CENTER: `${alignmentPoints.RIGHT}-${alignmentPoints.CENTER}`,

  // Top edge alignments
  TOP_TOP: `${alignmentPoints.TOP}-${alignmentPoints.TOP}`,
  TOP_BOTTOM: `${alignmentPoints.TOP}-${alignmentPoints.BOTTOM}`,
  TOP_CENTER: `${alignmentPoints.TOP}-${alignmentPoints.CENTER}`,

  // Bottom edge alignments
  BOTTOM_TOP: `${alignmentPoints.BOTTOM}-${alignmentPoints.TOP}`,
  BOTTOM_BOTTOM: `${alignmentPoints.BOTTOM}-${alignmentPoints.BOTTOM}`,
  BOTTOM_CENTER: `${alignmentPoints.BOTTOM}-${alignmentPoints.CENTER}`,

  // Center alignments
  CENTER_LEFT: `${alignmentPoints.CENTER}-${alignmentPoints.LEFT}`,
  CENTER_RIGHT: `${alignmentPoints.CENTER}-${alignmentPoints.RIGHT}`,
  CENTER_TOP: `${alignmentPoints.CENTER}-${alignmentPoints.TOP}`,
  CENTER_BOTTOM: `${alignmentPoints.CENTER}-${alignmentPoints.BOTTOM}`,
  CENTER_CENTER: `${alignmentPoints.CENTER}-${alignmentPoints.CENTER}`,
};
